const SET_SELECTED_ENTERPRISE = "SET_SELECTED_ENTERPRISE";

export function setSelectedEnterprise(payload) {
  return { type: SET_SELECTED_ENTERPRISE, payload };
}

const initialState = { selectedEnterprise: null };

export default function enterpriseReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_ENTERPRISE:
      return { ...state, selectedEnterprise: action.payload };
    default:
      return state;
  }
}
